/** User-facing SMS OTP copy (Firebase Phone Auth). */

export function getPhoneOtpSentMessage(language: "ar" | "en" = "ar"): string {
  return language === "en"
    ? "Verification code sent by SMS."
    : "تم إرسال رمز التحقق برسالة نصية";
}

export const PHONE_OTP_COPY = {
  ar: {
    sendHint: "سيتم إرسال رمز التحقق إلى رقمك في رسالة نصية",
    codeLabel: "أدخل رمز التحقق المرسل في الرسالة النصية",
    resend: "إعادة إرسال الرمز برسالة نصية",
    sending: "جاري إرسال رمز التحقق برسالة نصية...",
    sent: "تم إرسال رمز التحقق برسالة نصية",
  },
  en: {
    sendHint: "We will send your verification code by SMS.",
    codeLabel: "Enter the verification code sent by SMS.",
    resend: "Resend code by SMS.",
    sending: "Sending verification code by SMS...",
    sent: "Verification code sent by SMS.",
  },
} as const;
